import { Accordion, AccordionSummary, AccordionDetails, Typography, List, ListItem, ListItemText } from "@mui/material";
import { Iconify } from "../../common/iconify";

type Props = {
  publico: string[];
};

export const PublicoAgrupado: React.FC<Props> = ({ publico }) => {
  // Agrupamos por la parte antes del punto
  const agrupado = publico.reduce((acc: Record<string, string[]>, item) => {
    const [grupo, subgrupo] = item.split(".");
    if (!acc[grupo]) acc[grupo] = [];
    acc[grupo].push(subgrupo);
    return acc;
  }, {});

  return (
    <>
      {Object.entries(agrupado).map(([grupo, subgrupos]) => (
        <Accordion key={grupo}>
          <AccordionSummary expandIcon={<Iconify icon={"ic:baseline-expand-more"} />}>
            <Typography variant="subtitle1">{grupo}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List>
              {subgrupos.map((sub, index) => (
                <ListItem key={index}>
                  <ListItemText primary={sub} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};
